import React, { Fragment, useContext, useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { AuthContext } from "../../../common/Auth"
import axios from 'axios'
import {
    List, makeStyles, ListItem, ListItemText, ListItemSecondaryAction,
    TextField, Container, Button, FormControl, Select, Switch, MenuItem
} from "@material-ui/core";
import { connect } from "react-redux";
import { SETTINGS, THEME_URL, X_TENANT_ID, ALL_TAGS_URL } from '../../../common/ActionUrl'
import { _useToasts } from "../../../common/_useToasts";
import { useHistory } from "react-router-dom";
import { USERTYPES } from "../../../constant/userType"
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        className: "col-12",
        maxWidth: 600,
        backgroundColor: theme.palette.background.paper,
    }
}));

const TaggedProducts = ({ setTabName, tabName, handleClose }) => {
    const [formStates, setFormStates] = useState({
        sectionTitle: "DAILY DEALS!",
        sectionTitleEnabled: true,
        sectionSubTitle: "",
        sectionSubTitleEnabled: true,
        firstTabProductCat: "",
        secondTabProductCat: "",
        thirdTabProductCat: "",
        firstTabEnabled: true,
        secondTabEnabled: false,
        thirdTabEnabled: false,
    });
    const history = useHistory();
    const { _addToast } = _useToasts();

    const { user, userType, getThemeSettings } = useContext(AuthContext)
    const adminUserId = user?.userId

    const [themeId, setThemeId] = useState("")
    const [themeData, setThemeData] = useState({})
    const [tagData, setTagsData] = useState([])
    const [toggle, setToggle] = useState(false)
    useEffect(() => {
        if (Object.keys(themeData).length > 0) {
            let themeSettingData = themeData.filter(themeArray => themeArray.settingsName === "taggedProducts")
            if (themeSettingData[0]) {
                formStates.sectionTitle = themeSettingData[0].values[0].sectionTitle ? themeSettingData[0].values[0].sectionTitle : ""
                formStates.sectionTitleEnabled = themeSettingData[0].values[0].sectionTitleEnabled ? themeSettingData[0].values[0].sectionTitleEnabled : ""
                formStates.sectionSubTitle = themeSettingData[0].values[0].sectionSubTitle ? themeSettingData[0].values[0].sectionSubTitle : ""
                formStates.sectionSubTitleEnabled = themeSettingData[0].values[0].sectionSubTitleEnabled ? themeSettingData[0].values[0].sectionSubTitleEnabled : ""
                formStates.firstTabProductCat = themeSettingData[0].values[0].firstTabProductCat ? themeSettingData[0].values[0].firstTabProductCat : ""
                formStates.secondTabProductCat = themeSettingData[0].values[0].secondTabProductCat ? themeSettingData[0].values[0].secondTabProductCat : ""
                formStates.thirdTabProductCat = themeSettingData[0].values[0].thirdTabProductCat ? themeSettingData[0].values[0].thirdTabProductCat : ""
                formStates.firstTabEnabled = themeSettingData[0].values[0].firstTabEnabled ? themeSettingData[0].values[0].firstTabEnabled : ""
                formStates.secondTabEnabled = themeSettingData[0].values[0].secondTabEnabled ? themeSettingData[0].values[0].secondTabEnabled : ""
                formStates.thirdTabEnabled = themeSettingData[0].values[0].thirdTabEnabled ? themeSettingData[0].values[0].thirdTabEnabled : ""

                setThemeId(themeSettingData[0]._id)
                setToggle(!toggle)
            }
        }
    }, [themeData, tagData])
    const handleInputChange = (e, key) => {
        let tempData = { ...formStates }
        tempData[key] = e.target.value
        setFormStates(tempData)
    }
    const handleInputSwitchChange = (e, key) => {
        let tempData = { ...formStates }
        if (e.target.checked) {
            tempData[key] = true
        } else {
            tempData[key] = false
        }
        setFormStates(tempData)
    }

    const getTags = () => {
        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
        };
        axios.get(ALL_TAGS_URL + "?limit=500&offset=0&order=tagName&orient=asc", requestOptions)
            .then(res => {
                if (res.data.error) {
                    _addToast(res.data.message, {
                        appearance: "error",
                        autoDismiss: true
                    });
                } else {
                    if (res.data && res.data.results.length > 0) {
                        setTagsData(res.data.results)
                    }
                }
            })
            .catch(err => {
                console.log('err', err);
            });
    }
    const getThemeId = () => {
        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
        };
        axios.get(THEME_URL, requestOptions)
            .then(res => {

                if (res.data.error) {
                    _addToast(res.data.message, {
                        appearance: "error",
                        autoDismiss: true
                    });
                } else {
                    if (res.data) {
                        setThemeData(res.data)
                    }
                }
            })
            .catch(err => {
                console.log('err', err);
            });
    }

    useEffect(() => {
        getThemeId()
        getTags()
    }, []);

    async function createUserCallback() {

        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
        };
        let insertData = {
            settingsName: "taggedProducts",
            "values": {
                "sectionTitle": formStates.sectionTitle,
                "sectionTitleEnabled": formStates.sectionTitleEnabled,
                "sectionSubTitle": formStates.sectionSubTitle,
                "sectionSubTitleEnabled": formStates.sectionSubTitleEnabled,
                "firstTabProductCat": formStates.firstTabProductCat,
                "secondTabProductCat": formStates.secondTabProductCat,
                "thirdTabProductCat": formStates.thirdTabProductCat,
                "firstTabEnabled": formStates.firstTabEnabled,
                "secondTabEnabled": formStates.secondTabEnabled,
                "thirdTabEnabled": formStates.thirdTabEnabled,
                "createdBy": adminUserId
            }, userId: adminUserId
        }
        if (themeId) {
            axios.patch(THEME_URL + themeId, insertData, requestOptions)
                .then(res => {
                    if (res.data.error) {
                        _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        getThemeSettings()
                        handleClose()
                        _addToast("Theme updated successfully", {
                            appearance: "success",
                            autoDismiss: true
                        });
                    }
                }).catch((error, config, code, request, response) => {
                    if (error.response && error.response.data.statusCode === 409) {
                        _addToast(error.response.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        _addToast("Issues while update theme", {
                            appearance: "error",
                            autoDismiss: true
                        });
                    }
                });
        } else {
            axios.post(THEME_URL, insertData, requestOptions)
                .then(res => {
                    if (res.data.error) {
                        _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        getThemeSettings()
                        handleClose()
                        _addToast("Theme added successfully", {
                            appearance: "success",
                            autoDismiss: true
                        });
                    }
                })
                .catch((error, config, code, request, response) => {
                    if (error.response && error.response.data.statusCode === 409) {
                        _addToast(error.response.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else if (error.response && error.response.data.statusCode === 400) {
                        _addToast(error.response.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        _addToast("Issues while create theme", {
                            appearance: "error",
                            autoDismiss: true
                        });
                    }
                });
        }
    }
    const classes = useStyles();
    return (

        <div className="contact-area pt-10 pb-10">
            <div className="banner-form" style={{ 'minHeight': '50vh' }}>
                {userType !== USERTYPES.USER ?
                    <form className="banner-form-style">
                        {/* <div className="page-title">
                                Featured Products section settings
                                <Button className="float-right" variant="contained" color="primary" onClick={() => { handleClose() }}>Back</Button>
                            </div> */}

                        <div className="col-md-12">
                            <div className="row inputRow">
                                <div className="col-md-6 form-group">
                                    <label>Section Title</label>
                                    <Switch color="primary" checked={formStates.sectionTitleEnabled} onChange={(e) => handleInputSwitchChange(e, "sectionTitleEnabled")} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <input type="text" className={'form-control'} onChange={(e) => handleInputChange(e, "sectionTitle")} value={formStates.sectionTitle} aria-describedby="sectionTitle" />
                                </div>
                            </div>
                            <div className="row inputRow">
                                <div className="col-md-6 form-group">
                                    <label>Section Sub Title</label>
                                    <Switch color="primary" checked={formStates.sectionSubTitleEnabled} onChange={(e) => handleInputSwitchChange(e, "sectionSubTitleEnabled")} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <input type="text" className={'form-control'} onChange={(e) => handleInputChange(e, "sectionSubTitle")} value={formStates.sectionSubTitle} aria-describedby="sectionSubTitle" />
                                </div>
                            </div>
                            <div className="row inputRow">
                                <div className="col-md-6 form-group">
                                    <label>First tab products tag</label>
                                    <Switch color="primary" checked={formStates.firstTabEnabled} onChange={(e) => handleInputSwitchChange(e, "firstTabEnabled")} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <Select labelId="demo-simple-select-outlined-label" value={formStates.firstTabProductCat}
                                        onChange={(e) => { handleInputChange(e, "firstTabProductCat") }}
                                        name="firstTabProductCat">
                                        <MenuItem value=""> Select tag</MenuItem>
                                        {tagData && tagData.map((tag, index) => {
                                            return <MenuItem value={tag._id} key={index}> {tag.tagName}</MenuItem>
                                        })}
                                    </Select>
                                </div>
                            </div>
                            <div className="row inputRow">
                                <div className="col-md-6 form-group">
                                    <label>Second tab products tag</label>
                                    <Switch color="primary" checked={formStates.secondTabEnabled} onChange={(e) => handleInputSwitchChange(e, "secondTabEnabled")} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <Select labelId="demo-simple-select-outlined-label" value={formStates.secondTabProductCat}
                                        onChange={(e) => { handleInputChange(e, "secondTabProductCat") }}
                                        name="secondTabProductCat">
                                        <MenuItem value=""> Select tag</MenuItem>
                                        {tagData && tagData.map((tag, index) => {
                                            return <MenuItem value={tag._id} key={index}> {tag.tagName}</MenuItem>
                                        })}
                                    </Select>
                                </div>
                            </div>
                            <div className="row inputRow">
                                <div className="col-md-6 form-group">
                                    <label>Third tab products tag</label>
                                    <Switch color="primary" checked={formStates.thirdTabEnabled} onChange={(e) => handleInputSwitchChange(e, "thirdTabEnabled")} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <Select labelId="demo-simple-select-outlined-label" value={formStates.thirdTabProductCat}
                                        onChange={(e) => { handleInputChange(e, "thirdTabProductCat") }}
                                        name="thirdTabProductCat">
                                        <MenuItem value=""> Select tag</MenuItem>
                                        {tagData && tagData.map((tag, index) => {
                                            return <MenuItem value={tag._id} key={index}> {tag.tagName}</MenuItem>
                                        })}
                                    </Select>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
                            <button className="bannerbutton" type="button" onClick={() => { createUserCallback() }}>Save</button>
                        </div>
                    </form>
                    : ""}
            </div>
        </div>
    );
};

export default (TaggedProducts);
